export default function supportsWebMAlpha() {
  return new Promise((resolve, reject) => {

    let vid = document.createElement('video');
    vid.autoplay = false;
    vid.loop = false;
    vid.style.display = false;
    vid.addEventListener("loadeddata", ()=>{

      document.body.removeChild(vid);
      let canvas = document.createElement('canvas');
      if(!(canvas.getContext && canvas.getContext('2d'))){
        resolve(false);
      }
      let ctx = canvas.getContext('2d');
      ctx.drawImage(vid, 0, 0);
      if (ctx.getImageData(0, 0, 1, 1).data[3] === 0) {

          resolve(true);
      } else {

          resolve(false);
      }
    }, false);

    vid.addEventListener("error", ()=> {
      document.body.removeChild(vid);

      resolve(false);
    });

    vid.addEventListener("stalled", function()
  {
      document.body.removeChild(vid);


      resolve(false);
  });

  //Just in case
  vid.addEventListener("abort", function()
  {
      document.body.removeChild(vid);


      resolve(false);
  });

  var source = document.createElement("source");
  source.src="data:video/webm;base64,GkXfowEAAAAAAAAfQoaBAUL3gQFC8oEEQvOBCEKChHdlYm1Ch4ECQoWBAhhTgGcBAAAAAAACBRFNm3RALE27i1OrhBVJqWZTrIHlTbuMU6uEFlSua1OsggEjTbuMU6uEHFO7a1OsggHo7AEAAAAAAACqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmAQAAAAAAADIq17GDD0JATYCNTGF2ZjU3LjU3LjEwMFdBjUxhdmY1Ny41Ny4xMDBEiYhARAAAAAAAABZUrmsBAAAAAAAARq4BAAAAAAAAPdeBAXPFgQGcgQAitZyDdW5khoVWX1ZQOYOBASPjg4QCYloA4AEAAAAAAAARsIFAuoFAmoECU8CBAVSygQQfQ7Z1AQAAAAAAAGfngQCgAQAAAAAAAFuhooEAAACCSYNCAAPwA/YAOCQcGFQAADBgAABnP///NXgndmB1oQEAAAAAAAAtpgEAAAAAAAAk7oEBpZ+CSYNCAAPwA/YAOCQcGFQAADBgAABnP///Vttk7swAHFO7awEAAAAAAAARu4+zgQC3iveBAfGCAXXwgQM=";

  source.addEventListener("error", function()
  {
     document.body.removeChild(vid);
     resolve(false);
  });

  vid.appendChild(source);
  //This is required for IE
  document.body.appendChild(vid);

  })
}
